import { AboutMeCard } from "./AboutMeCard";
import Blog from "./Blog";
import NavigationBar from "./NavigationBar";
import ParticlesBackground from './ParticlesBackground';



export const Resume = () => {
    return (
        <div className="flex flex-col bg-purple-200 ">
           <ParticlesBackground /> 
            <NavigationBar />
        
            <div className="lg:flex lg:flex-row hidden lg:h-[24rem] 1.5lg:h-80 justify-center">
                {/* {SmallCardList('', [], '🔧', 'rounded-r-lg', true)} */}
                <AboutMeCard />
                {/* {SmallCardList('', [], '📔', 'rounded-l-lg', false)} */}
            </div>
            
            <div className="lg:hidden flex justify-center z-10">
                {AboutMeCard({hideBackCard: true})}
            </div>
            
            <div className="h-3/4 mt-10 w-100 flex flex-col justify-center" id="work">
                <div className="w-100  text-center font-bold flex justify-center mb-10">
                    <div className="bg-gradient-to-r from-red-400 to-pink-500 w-10/12 p-5 drop-shadow-xl rounded-lg">Work</div>
                </div>
                <div className="flex flex-col h-full w-full items-center">
                    <div className="md:flex-row flex-col w-10/12 flex bg-gradient-to-b from-purple-400  to-purple-600 drop-shadow-xl rounded-lg">
                        <div className="md:w-1/6 md:bg-gradient-to-b bg-gradient-to-r from-fuchsia-400 to-pink-500 rounded-lg text-left align-middle p-5">
                            <div className="show-on-scroll">
                                <span className="font-bold italic">Analyst</span> @ <span className="font-bold">Goldman Sachs</span>
                            </div>
                            {/* <div id="work"><span className="font-bold italic">Analyst</span> @</div>
                            <div className="font-bold">Goldman Sachs</div> */}
                            <div className="italic show-on-scroll">July 2021 - Present</div>
                        </div>
                        <div className="p-5 show-on-scroll md:w-5/6">
                            <p className="text-lg font-semibold">Backend</p>
                            <ul className="list-disc pl-5">
                                <li className="show-on-scroll">
                                    Working on a large-scale inventory management platform that is responsible for optimal handling of the firm's financial inventory.
                                    The platform consists of a linear optimizer (written in Mosek) supported by various microservices written in Java
                                </li>
                                <li>
                                    Involved in the migration of a legacy platform to a newer platform written in Java
                                </li>
                                <li className="show-on-scroll">Worked on the development of streaming applications with capability to compute real-time aggregations from various data sources using Apache Kafka
                                </li>
                                <li className="show-on-scroll">
                                    Responsible for the development and productionization of an ETL pipeline (using Apache Kafka) to improve operational 
                                    efficiency with annual transaction cost savings upwards of 2.5 Million USD. 
                                    Project entailed interaction with external vendor and multiple internal teams 
                                </li>
                                <li className="show-on-scroll">
                                    Improved ease of blue-green deployment by eliminating manual reconciliation actions needed to transfer traffic from one deployment to the other. 
                                    Wrote extensive MySQL queries for reconciling data between environments
                                </li>
                                <li className="show-on-scroll">
                                    Worked on multiple calculators to expose data to the frontend through a pre-existing REST Service. 
                                    Queries were written in SQL and Apache Spark
                                </li>
                                <li className="show-on-scroll"><span className="font-bold">Languages/Frameworks:</span> Java, Apache Spark, Apache Kakfa, RESTful APIs, MySQL, Junit, Fitnesse</li>
                            </ul>
                            <p className="text-lg font-semibold pt-5">Frontend</p>
                            <ul className="list-disc pl-5">
                                <li className="show-on-scroll">Worked on multiple UI dashboards for the platform using React and Javascript</li>
                                <li>Well-versed in grid frameworks like AG Grid and have worked on server side rendering models</li>
                                <li>Adept at utilizing RESTful API's to render infinite scrolling grids using AG Grid and charts using Highcharts</li>
                                <li>Adept at utilising Redux for state management</li>
                                <li>Familiar with snapshot and extensive unit testing using Jest</li>
                                <li>
                                    <span className="font-bold">Languages/Frameworks:</span> React, Redux, RESTful APIs, AG Grid, Highcharts, Jest
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="w-10/12 flex md:flex-row flex-col bg-gradient-to-b from-purple-400  to-purple-600 drop-shadow-xl rounded-lg mt-10">
                        <div className="md:w-1/6 md:bg-gradient-to-b bg-gradient-to-r from-fuchsia-400 to-pink-500 rounded-lg text-left align-middle p-5">
                            <div className="show-on-scroll">
                                <span className="font-bold italic">Summer Analyst</span> @ <span className="font-bold">Goldman Sachs</span>
                            </div>
                            
                            <div className="italic">May 2020 - June 2020</div>
                        </div>
                        <div className="p-5 show-on-scroll md:w-5/6">
                            <ul className="list-disc pl-5">
                                <li className="show-on-scroll">
                                    Developed an interactive network diagram for an inventory management optimization platform to visualize movements across nodes within a graph.
                                </li>
                                <li className="show-on-scroll">The graph comprised of a series of locations (nodes) and a series of permissible movements (flows). 
                                    The permissible movements were generated by a pre-exisiting optimzer.
                                </li>
                                <li className="show-on-scroll">Each location consisted of a balance that could move across the locations across complex paths.</li>
                                <li className="show-on-scroll">The project utilized GraphQL as a middleware layered on an exisiting REST API.</li>
                                <li className="show-on-scroll">Calls to the REST API were filtered out by GraphQL queries - to only get the requisite fields.</li>
                                <li className="show-on-scroll">These were then displayed in an acceptable format using React and D3.js</li>
                                <li id="work"><span className="font-bold show-on-scroll">Languages/Frameworks:</span> GraphQL, React, D3</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div id="education" className="w-100 h-3/4 flex flex-col items-center mb-10">
                <div className="bg-gradient-to-r from-red-400 to-pink-500 w-10/12 p-5 font-bold text-center drop-shadow-xl rounded-lg mt-10">Education</div>
                <div className="flex flex-col lg:flex-row items-center lg:justify-center">
                    {/* {SmallCardList('Compeitions', ['Java', 'Jvascirpt'])} */}
                    <div className="flex flex-col md:flex-row w-10/12 mt-10 drop-shadow-xl">
                        <div className="lg:w-2/5 md:bg-gradient-to-b bg-gradient-to-r from-fuchsia-400 to-pink-500 rounded-t-lg md:rounded-r-none md:rounded-l-lg text-left align-middle p-5">
                            <div><span className="font-bold italic show-on-scroll">B.Tech</span> @</div>
                            <div className="font-bold show-on-scroll">National Institute of Technology, Tiruchirappalli</div>
                            <div className="italic show-on-scroll">
                                July 2017 - June 2021
                                <span className="visible md:hidden pl-2"><span className="font-bold">CGPA</span>: 9.12/10</span>
                            </div>
                            <div className="hidden md:visible show-on-scroll">CGPA: 9.12/10</div>
                        </div>
                        <div className="p-5 pl-10 lg:w-11/12 bg-gradient-to-b from-purple-400  to-purple-600 show-on-scroll">
                            <span className="font-bold">Projects</span>
                            <ul className="list-disc pt-3">
                                <li>
                                    <span className="font-bold show-on-scroll">Multi Document Abstractive Summarization for PPT Generation</span> (<span className="italic">Final Year Project</span>) - 
                                    Goal was to generate abstractive summaries of large scientific articles and corpuses and present it as a power point 
                                    presentation in the most efficient way.
                                </li>
                                <li className="pt-5"> 
                                    <span className="font-bold show-on-scroll">Theoretical Knowledge transfer of Controller Area Network to BHEL Employees</span> - Conducted multiple sessions for employees who 
                                    were going to use it as part of their ongoing project to build electric buses in the district of Tiruchirappalli.
                                </li>
                            </ul>
                            <br />
                        </div>
                        <div className="lg:w-4/12 bg-gradient-to-b from-fuchsia-400 to-pink-500 rounded-b-lg md:rounded-r-lg md:rounded-l-none  p-5 pl-10">
                        <div className="font-bold show-on-scroll">Volunteering</div>
                        <ul className="list-disc pt-3">
                            <li className=""> 
                                <span className="font-bold show-on-scroll">Writing Club</span> - Wrote articles, stories, poems, and social media content for the annual cultural festival of the college
                            </li>
                            <li className="pt-5">
                                <span className="font-bold show-on-scroll">Social Responsibility Club</span> - Volunteered at a competition conducted at a primary school and a day-long event held at a center for blind women
                            </li>
                        </ul>
                        {/* {SmallCardList('Volunteering', volunteeringText, '', 'rounded-lg', false)} */}
                    </div>
                    </div>
                    
                </div>
            </div>
            <footer className="font-bold z-10 text-center font-mono">
                Built with ❤️ <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-800 to-orange-800"><a href="https://tailwindcss.com/">Tailwind</a></span>, <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-800 to-green-800"><a href="https://vincentgarreau.com/particles.js/">ParticlesJS</a></span>
            </footer>
        </div>
    );
};

export default Resume;